import { render } from "./Modal.vue?vue&type=template&id=d0c758ba"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=d0c758ba&lang=css"

import exportComponent from "C:\\Users\\TATS\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\tsg-exec\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__